/* eslint no-eval: 0 */

import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import React, { Fragment, useEffect, useState } from 'react';
//style={{ color: 'purple' }}
import { Datagrid, FunctionField, List, ShowButton, TextField } from 'react-admin';
import ResetViewsButton from '../bulk/ResetViewsButton';
import FormDialogPayement from '../dialog/FormDialogPayement.js';
import FiltreRecherche from '../filtres/FiltreRecherche';
//import ExportAgExp from './ExportAgExp';
import PostPagination from '../paginations/pagination';
import { has_role } from '../references';
import rowStyleLivraison from '../styles/rowStyleLivraison';

 const  ListLivraison=(props)=>{

    const [fullname, setFullname] = useState('');
    const [reste_a_payer, setReste_a_payer] = useState();
    //const [roles, setRole] = useState();
    const [campType, setCampType] = useState();
    const [haveAuthorized, setHaveAuthorized] = useState(false);
    const {permissions,resource}=props;

    useEffect(() => {
        setFullname(localStorage.getItem('fullname'));
        //setRole(localStorage.getItem('roles'));
    }, []);

    const selectableAerien=(livre_user_id,camp_type,status)=>{
       return  ((livre_user_id===null || livre_user_id===0 ) && !has_role(permissions,'ROLE_MANAGER')) &&
       (((camp_type==='AERIEN' || camp_type==='MARITIME') && has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI')) ||
       ((camp_type==='AERIEN_DE_CNKRY') && has_role(permissions,'ROLE_AG_EXP_AERIEN_FR'))) && 
       (status!=='ASK') || (has_role(permissions,'ROLE_MANAGER') && status==='ASK')
    }
 return(
        <List {...props} 
                bulkActionButtons={<PostBulkActionButtons  {...props}  reste_a_payer={reste_a_payer} roles={permissions} campType={campType} haveAuthorized={haveAuthorized}/>}
               // actions={<ListActions/>}
                pagination={<PostPagination  {...props} />}
                filters={<FiltreRecherche {...props} />} 
                //filterDefaultValues={has_role(permissions,'ROLE_AG_EXP_AERIEN_FR') ? {"camp_type":"AERIEN_DE_CNKRY"}: {"camp_type":"AERIEN"}} 
                sort={{ field: 'id', order: 'ASC' }}
                title={'Livraison - '+fullname}
                empty={false}
            >
                
            <Datagrid rowStyle={rowStyleLivraison} isRowSelectable={record =>selectableAerien(record.livre_user_id,record.camp_type,record.status)} >
                <TextField source="numCodeEtiq" label="Code" style={{ color: 'purple'  }} sortBy="numCodeEtiq"/>
                <TextField source="camp_type" label="Type" />
                <TextField source="fullname_exp" label="Expéditaire" />
                <TextField source="fullname_dst" label="Destinataire" />
                <TextField source="reste_a_payer" label="Reste à payer (€)" sortBy="reste_a_payer"/>
                <TextField source="nom_livraire" label="Message" sortBy="nom_livraire"/>
                <FunctionField render={record => <ShowButton basePath={'/aerien/'+record.ord_id+'/show'} label="Afficher" record={record} /> } />
                <FunctionField render={record =>(record.reste_a_payer && !has_role(permissions,'ROLE_MANAGER')) ?  <FormDialogPayement from="list" for='livraison' data={record}/> :  null } />
                <FunctionField render={record => setReste_a_payer(record.reste_a_payer) } />
                <FunctionField render={record => setCampType(record.camp_type) } />
                <FunctionField render={record => record.status==='AUTHORISE' ? setHaveAuthorized(true):setHaveAuthorized(false) } />
                
            </Datagrid>
        </List>
       ) ;
    };

export default ListLivraison;

const get_url=(reste_a_payer,selectedIds,campType,permissions,haveAuthorized)=>{
    var url=null;
    if(has_role(permissions,'ROLE_MANAGER') && reste_a_payer>0 && !haveAuthorized){
        url='/etiq/livreParManager?ids=' + selectedIds;
    }else{
        url= !has_role(permissions,'ROLE_MANAGER') && reste_a_payer > 0 && !haveAuthorized? 
        '/etiq/auhthoLivraisonAvecReste?ids=' + selectedIds+'&campType='+campType :
        '/etiq/updateLivraisonEtiq?ids=' + selectedIds+'&campType='+campType;
    }

    return process.env.REACT_APP_URL +url;
}

const PostBulkActionButtons = props => (
    <Fragment >
        <ResetViewsButton label={!has_role(props.roles,'ROLE_MANAGER') && props.reste_a_payer > 0  && !props.haveAuthorized ? 'Authorisation': 'Livré'}
            title={!has_role(props.roles,'ROLE_MANAGER') && props.reste_a_payer > 0 && !props.haveAuthorized ? "Demende d'authorisation de livraison":'Livraison des colis séléctionnés'}
            content={!has_role(props.roles,'ROLE_MANAGER') && props.reste_a_payer > 0 && !props.haveAuthorized ? "Voulez vous demander une authorisation de livraison des colis sélectionnés":'Voulez vous livrer les colis séléctionnés ?'} {...props} 
            url={get_url(props.reste_a_payer,props.selectedIds,props.campType,props.roles,props.haveAuthorized)}
            startIcon={<LocalShippingIcon/>}
            {...props} 
        />
    </Fragment>
);

/*
const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        hasCreate,
        basePath,
        selectedIds,
        showFilter,
        total,
    } = useListContext();
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
        
            <CreateButton basePath={basePath} />
        </TopToolbar>
    );
};
*/






/*
const GuetsiAction = ({
    bulkActions,
    basePath,
    currentSort,
    displayedFilters,
    exporter,
    filters,
    filterValues,
    onUnselectItems,
    resource,
    selectedIds,
    showFilter,
    total,
    data,
    record,
    ...rest
}) => (
    <TopToolbar>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
            record,
            data
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        }) }
        
        <Button source="credit_status" label="Colis"  color="primary" onClick={()=>this.handleClick()}> <VerticalSplit /> </Button>  
        <CreateButton basePath={basePath} />

    </TopToolbar>
);



*/